import type { routerViewLocationKey } from 'vue-router';
<template>
  <div class="tabsAccounts-content margin-general">
    <div class="buttonsContainer" ref="buttonsContainer">
      <button
        v-for="tab in tabs"
        :key="tab.name"
        class="buttonItem"
        :class="{ selected: selected === tab.value }"
        @click="selectTab(tab.value)"
      >
        {{ $t(tab.label) }}
      </button>

      <span class="selected-border" :style="borderStyle">
        <div class="border-style"></div>
      </span>
    </div>

    <div
      class="card-content"
      v-for="row in categories[selected]"
      :key="row.index"
    >
      <h3>{{ $t(row.title) }}</h3>
      <p class="body-4 descr">{{ $t(row.description) }}</p>

      <SelectCustom
        class="selectItem"
        :options="tabs"
        v-model="selected"
      />

      <div class="forex-content" v-if="selected === 'forex'">
        <div class="card-content-item">
          <div class="items-content">
            <div v-for="item in cardsForex" :key="item.index" class="card">
              <div class="content">
                <p class="title body-6-bold">{{ $t(item.title) }}</p>
                <div class="line"></div>
                <div class="desc" :class="{ futures: selected === 'futures' }">
                  <div class="" v-for="li in item.items" :key="li.index">
                    <span class="material-symbols-outlined" translate="no">check</span>
                    <p class="body-4">{{ $t(li.column1) }}</p>
                  </div>
                </div>
              </div>
              <a target="_blank" :href="getExternalUrl('/register/1/live-account')" class="second-button-small body-4-bold"
                 rel="noopener noreferrer">
                {{ $t("accounts.tabsAccounts.forex.cards.btn") }}
                </a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="stocks-content" v-if="selected === 'stocks'">
        <div class="items-content">
          <!-- <TableComponent :titleCards="titleCardsStocks" :cards="cardsStocks" /> -->
          <div v-for="item in cardsStocks" :key="item.index" style="max-width: 350px;" class="card">
            <div class="content">
              <p class="title body-6-bold">{{ $t(item.title) }}</p>
              <div class="line"></div>
              <div class="desc" :class="{ futures: selected === 'futures' }">
                <div class="" v-for="li in item.items" :key="li.index">
                  <span class="material-symbols-outlined" translate="no">check</span>
                  <p class="body-4">{{ $t(li.column1) }}</p>
                </div>
              </div>
            </div>
          </div>
          <a target="_blank" :href="getExternalUrl('/register/1/live-account')" class="primary-button-medium"
             rel="noopener noreferrer">
            {{ $t("accounts.tabsAccounts.stocks.cards.btn") }}
            </a
          >
          <div class="card">
            <div class="content">
              <p class="title body-6-bold">
                {{ $t("accounts.tabsAccounts.stocks.cardOtherC.title") }}
              </p>
              <div class="line"></div>
              <div class="desc">
                <div class="">
                  <span class="material-symbols-outlined" translate="no">check</span>
                  <p class="body-4">
                    {{ $t("accounts.tabsAccounts.stocks.cardOtherC.item1") }}
                  </p>
                </div>
                <div class="">
                  <span class="material-symbols-outlined" translate="no">check</span>
                  <p class="body-4">
                    {{ $t("accounts.tabsAccounts.stocks.cardOtherC.item2") }}
                  </p>
                </div>
                <div class="">
                  <span class="material-symbols-outlined" translate="no">check</span>
                  <p class="body-4">
                    {{ $t("accounts.tabsAccounts.stocks.cardOtherC.item3") }}
                  </p>
                </div>
                <div class="">
                  <span class="material-symbols-outlined" translate="no">check</span>
                  <p class="body-4">
                    {{ $t("accounts.tabsAccounts.stocks.cardOtherC.item5") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="future-content" v-if="selected === 'futures'">
        <div class="card-content-item">
          <div class="items-content">
            <div v-for="item in cardsFutures" :key="item.index" class="card">
              <div class="content">
                <p class="title body-6-bold">{{ $t(item.title) }}</p>
                <div class="line"></div>
                <div class="desc" :class="{ futures: selected === 'futures' }">
                  <div class="" v-for="li in item.items" :key="li.index">
                    <span class="material-symbols-outlined" translate="no">check</span>
                    <p class="body-4">{{ $t(li.column1) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="date-commisions">
            <p class="title body-3-bold">{{ $t("accounts.tabsAccounts.futures.date-comissions.title") }}</p>
            <div class="card-cont">
              <div class="card">
                <p class="body-4-bold">{{ $t("accounts.tabsAccounts.futures.date-comissions.titlecard") }}</p>
                <span class="comission">$0.99</span>
                <p class="caption-1">{{ $t("accounts.tabsAccounts.futures.date-comissions.text-card") }}</p>
              </div>
              <div class="card">
                <p class="body-4-bold">{{ $t("accounts.tabsAccounts.futures.date-comissions.titlecard2") }}</p>
                <span class="comission">$0.49</span>
                <p class="caption-1">{{ $t("accounts.tabsAccounts.futures.date-comissions.text-card2") }}</p>
              </div>
            </div>
            <p class="disclaimer body-4">{{ $t("accounts.tabsAccounts.futures.date-comissions.disclaimer") }}</p>
          </div>
          <div class="cont_diclaimer">
            <p class="disclaimer caption-1">
              {{ $t("accounts.tabsAccounts.futures.cards.descDesclaimer") }}
            </p>
            <p class="disclaimer caption-1">
              {{ $t("accounts.tabsAccounts.futures.cards.descDesclaime1") }}
            </p>
            <p class="disclaimer caption-1">
              {{ $t("accounts.tabsAccounts.futures.cards.descDesclaime2") }}
            </p>
            <p class="disclaimer caption-1">
              {{ $t("accounts.tabsAccounts.futures.cards.descDesclaime3") }}
            </p>
            <p class="disclaimer caption-1">
              {{ $t("accounts.tabsAccounts.futures.cards.descDesclaime4") }}
            </p>
            <p class="disclaimer caption-1">
              {{ $t("accounts.tabsAccounts.futures.cards.descDesclaime5") }}
            </p>
          </div>
          <a target="_blank" :href="getExternalUrl('/register/1/live-account')" class="primary-button-medium"
             rel="noopener noreferrer">
            {{ $t("accounts.tabsAccounts.futures.cards.btn") }}
            </a
          >
        </div>
      </div>

      <div class="content-detail">
        <div class="text">
          <h3 class="title-detail">{{ $t(row.text.title) }}</h3>
          <p class="body4" v-html="$t(row.text.desc)"></p>
        </div>
        <div class="detail">
          <div v-for="(opt, index) in row.details" class="option" :key="index">
            <div class="icon">
              <span class="material-symbols-outlined" translate="no">{{ opt.icon }}</span>
            </div>
            <div class="text-detail">
              <p class="subtitle-4 bold">{{ $t(opt.title) }}</p>
              <p class="body-4">{{ $t(opt.description) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import SelectCustom from "../utils/select/SelectCustom.vue";

const { getExternalUrl } = useExternalUrl();

const props = defineProps({
  tabs: Object,
  selected: String,
  categories: Object,
  cardsForex: Object,
  cardsStocks: Object,
  titleCardsStocks: Object,
  cardsFutures: Object,
});

const selected = ref(props.tabs[0].value);
const selectedButtonIndex = ref(0);
const borderStyle = ref({});
const buttonsContainer = ref(null); // Define la referencia aquí

function selectTab(tabName) {
  const newIndex = props.tabs.findIndex((tab) => tab.value === tabName);
  if (newIndex !== -1) {
    selected.value = tabName;
  }
  selectedButtonIndex.value = newIndex;
  updateBorderBottomStyle();
}

function initializeBorderBottomStyle() {
  const button = buttonsContainer.value.children[selectedButtonIndex.value];
  if (button) {
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
}

function updateBorderBottomStyle() {
  const button = buttonsContainer.value.children[selectedButtonIndex.value];
  if (button) {
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
}

onMounted(() => {
  initializeBorderBottomStyle();
  selected.value = props.tabs[0].value;
});
</script>
